import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IAdjustmentReadResourceV22, IBasketAdjustment } from 'components/basket/model/Basket';
import { isNumber, isString } from 'lib/typeInference';
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useCurrencyString } from 'lib/useCurrencyString';
import { addOpacity } from 'lib/helpers';
import { EGAEventName, useGAHelpers } from 'lib/useGAHelpers';

const PREFIX = 'CouponItem';

const classes = {
    subtitle: `${PREFIX}subtitle`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    [`& .${classes.subtitle}`]: {
        color: addOpacity(theme.palette.text.primary, 0.4),
        lineHeight: 1.35
    }
}));

interface CouponItemProps {
    adjustment: IAdjustmentReadResourceV22 | IBasketAdjustment;
    onClick: (couponCode: string) => void;
}

export const CouponItem: React.FC<React.PropsWithChildren<CouponItemProps>> = ({ onClick, adjustment }) => {
    const { logUserEvent } = useGAHelpers();
    const handleClick = React.useCallback(() => {
        if (isString(adjustment.couponCode)) {
            onClick(adjustment.couponCode);
            logUserEvent(EGAEventName.CheckoutCouponRemoved);
        }
    }, [adjustment.couponCode, logUserEvent, onClick]);
    const getCurrencyString = useCurrencyString();
    return (
        <StyledBox key={adjustment.couponCode}>
            <Box>
                <Typography>{adjustment.description}</Typography>
                <Typography variant="body2" className={classes.subtitle}>
                    {adjustment.couponCode}
                </Typography>
                {isNumber(adjustment.value) && (
                    <Typography variant="body2" className={classes.subtitle}>
                        {getCurrencyString(adjustment.value)}
                    </Typography>
                )}
            </Box>
            <Box onClick={handleClick} pl={5} pr={1} display="flex" alignItems="center">
                <ClearIcon />
            </Box>
        </StyledBox>
    );
};
